import { render } from "./FooterAuth.vue?vue&type=template&id=6bae8e1b&scoped=true"
import script from "./FooterAuth.vue?vue&type=script&lang=js"
export * from "./FooterAuth.vue?vue&type=script&lang=js"

import "./FooterAuth.vue?vue&type=style&index=0&id=6bae8e1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bae8e1b"]])

export default __exports__